import { Checkbox } from 'components/CheckboxGroup/Checkbox'
import Styles from './CrosspostTactics.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import cx from 'classnames'
import { useIsOnboardingRedesign } from 'hooks/useIsOnboardingRedesign'
import { ChannelIntegrationButton } from 'components/FirstTimeExperienceModal/steps/BrandPlanTactics/ChannelIntegrationButton'
import { useHover } from '@react-aria/interactions'
import { Icon as IconType } from 'blaze-ui/icons/Types'
import { Lock3 } from 'blaze-ui/icons'
import { Pill } from 'components/Pill/Pill'

type ComingSoonTacticCheckboxProps = {
  applyRedesign?: boolean
  icon: IconType
  label: string
}

export const ComingSoonTacticCheckbox = ({
  applyRedesign = false,
  icon: Icon,
  label,
}: ComingSoonTacticCheckboxProps) => {
  const isOnboardingRedesign = useIsOnboardingRedesign() && applyRedesign
  const { isHovered, hoverProps } = useHover({})
  const textVariant = isOnboardingRedesign ? 'primary' : 'largeList'

  return (
    <div className={Styles.checkboxContainer} {...hoverProps}>
      <Checkbox
        value={''}
        size={20}
        color="var(--selected-fill)"
        aria-label={label}
        className={cx(Styles.checkbox, { [Styles.applyRedesign]: isOnboardingRedesign })}
        isDisabled
      >
        <div className={Styles.checkboxContent}>
          {isOnboardingRedesign && (
            <div className={Styles.lockIcon}>
              <Lock3 size={12} color="var(--dark-40)" />
            </div>
          )}
          <div className={cx(Styles.checkboxLabel, Styles.comingSoonCheckboxLabel)}>
            <Icon size={20} />
            <Text variant={textVariant} color="var(--dark-80)">
              {label}
            </Text>
            <Pill className={Styles.comingSoonPill} size="sm">
              Coming Soon
            </Pill>
          </div>
          {isOnboardingRedesign && (
            <div className={Styles.channelIntegrationButton}>
              <ChannelIntegrationButton isHovered={isHovered} provider={undefined} isDisabled />
            </div>
          )}
        </div>
      </Checkbox>
    </div>
  )
}
